import React from "react";
import Hero from "../components/Hero";

function Home() {
  return (
    <div className="page page-home">
      <Hero />

      {/* Story section */}
      <section className="section section-light fade-up">
        <div className="section-inner">
          <h2>Our Story</h2>
          <p>
          <p>In 2022, their paths finally crossed after years of almost-meeting—two left-handed kids from Baltimore whose lives had quietly moved along similar tracks. They had walked the same halls at Baltimore Polytechnic Institute, shared the same city rhythms, and even spent time in many of the same places, yet somehow their story waited until the moment was right.</p>

          <p>Their first date came in February, just around Valentine’s Day. What began as a simple evening quickly turned into hours of laughter and easy conversation. He was drawn to her determination and warmth, while she discovered in him someone steady, encouraging, and full of life. Though both had a bit of stubbornness, the connection between them was undeniable.</p>

          <p>By September 9th, 2022, they chose to fully trust what they had found in one another and give their relationship a real chance. From that moment on, they began building something rooted in patience, encouragement, and the willingness to grow side by side.</p>

          <p>At the time, she was finishing nursing school while he supported and encouraged her along the way, celebrating with her when she completed the program later that year. Around the same time, he began discovering a passion for golf, and she was often right there beside him at the driving range—sometimes studying, sometimes recording his swing, and occasionally taking a few left-handed swings herself.</p>

          <p>Through 2023 and into 2024, their lives filled with shared experiences. They traveled together, from a road trip to South Carolina to a memorable trip to California where she conquered her fear of flying. They explored the mountains of Palm Springs, enjoyed date nights, played golf, and created countless memories closer to home—from Orioles games to boat rides across the Chesapeake Bay.</p>

          <p>They celebrated holidays together, spent meaningful time with family, and continued encouraging each other’s goals. When she supported his decision to return to school and finish his degree, their partnership grew even stronger—becoming teammates not only in life but also in their ambitions.</p>

          <p>In 2024, they stepped even further into building their future. They moved in together, supported one another through life’s challenges, and soon discovered they were preparing for their greatest blessing yet. On December 30th, 2024, they welcomed their son into the world, beginning a beautiful new chapter as a family.</p>

          <p>Through sleepless nights, new routines, and the joy of raising their child, their love continued to grow stronger. That following summer, during the weekend of their birthdays—his on July 22nd and hers on July 25th—he asked her to marry him.</p>

          <p>Two Baltimore hearts.
            Four years apart.
            Two left hands.
            And a path that seemed destined to cross.</p>

          <p>And now, after everything they have walked through, prayed for, and grown through together…</p>

          <p>They can’t wait to celebrate this love with you.</p>
          </p>
        </div>
      </section>

      {/* Timeline / Highlight section */}
      <section className="section section-soft fade-up">
        <div className="section-inner section-grid-two">
          <div>
            <h3>Wedding Day Highlights</h3>
            <ul className="bullet-list">
              <li>Ceremony • 4:15 PM</li>
              <li>Reception & Dancing • 7:00 PM</li>
            </ul>
          </div>
          <div className="photo-card">
            {/* Replace these placeholders with real images later */}
            <div className="photo-card-img placeholder-photo"></div>
          </div>
        </div>
      </section>

      {/* Another photo strip */}
      <section className="section section-light fade-up">
        <div className="section-inner photo-strip">
        <div className="photo-strip-item">
            <img src="/photo1.jpg" alt="Photo 1" />
        </div>
        <div className="photo-strip-item">
            <img src="/photo2.jpg" alt="Photo 2" />
        </div>
        <div className="photo-strip-item">
            <img src="/photo3.jpg" alt="Photo 3" />
        </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
